import axios from "axios";
// var goodsData = require('../data.json')

export function getNavData() {
	return axios({
		url: '/api/nav.json',
		method: 'GET'
	})
}
